import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import CompanySidebar from "./CompanySidebar";
import CompanyTopNavbar from "./CompanyTopNavbar";
import useCompanyAuth from "hooks/useCompanyAuth";
import GlobalModalManager from "components/ui/GlobalModalManager";

// Import Company Pages
import CompanyDashboard from "pages/company/CompanyDashboard";
import CompanyUsers from "pages/company/CompanyUsers";
import CompanyGodowns from "pages/company/CompanyGodowns";
import CompanyUserRoles from "pages/company/CompanyUserRoles";
import CompanyPreferences from "pages/company/CompanyPreferences";
import CompanyChangePassword from "pages/company/CompanyChangePassword";
import CompanyBackup from "pages/company/CompanyBackup";
import CompanyApiTokens from "pages/company/CompanyApiTokens";

export default function CompanyLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticated } = useCompanyAuth();

  // Redirect to company login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/company-login" replace />;
  }

  return (
    <div>
      <GlobalModalManager />
      <CompanySidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="lg:pl-72">
        <CompanyTopNavbar setSidebarOpen={setSidebarOpen} />
        <main className="py-10">
          <div className="px-4 sm:px-6 lg:px-8">
            <Routes>
              <Route path="/dashboard" element={<CompanyDashboard />} />
              <Route path="/users" element={<CompanyUsers />} />
              <Route path="/godowns" element={<CompanyGodowns />} />
              <Route path="/user-roles" element={<CompanyUserRoles />} />
              <Route path="/preferences" element={<CompanyPreferences />} />
              <Route path="/api-tokens" element={<CompanyApiTokens />} />
              <Route path="/change-password" element={<CompanyChangePassword />} />
              <Route path="/backup" element={<CompanyBackup />} />
              <Route path="/" element={<Navigate to="/company/dashboard" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}

